
import barba from '@barba/core';

export default class{

	constructor(){
        barba.hooks.beforeOnce((data) => {
            this.init()
        })
        barba.hooks.enter((data) => {
            this.init()
        });
    }
    init (){
        const checkAlls = document.querySelectorAll('[data-check-all]')
        if(checkAlls.length > 0){
            checkAlls.forEach(c => {
                this._attachCheckAll(c)
            })
        }

        const toggles = document.querySelectorAll('[data-filter-toggle]')

        if(toggles.length > 0){
            toggles.forEach(t => {
                this._attachToggle(t)
            })
        }

        const projectToggles = document.querySelectorAll('[data-project-toggle]')

        if(projectToggles.length > 0){
            projectToggles.forEach(t => {
                this._attachProjectToggle(t)
            })
        }

    }
    _attachCheckAll(el){
        
        el.addEventListener( 'click', (e) => {
            const active = el.classList.contains('-active')
            const id = el.getAttribute('data-check-all')
            const wrapper = document.querySelector('#' + id )
            const inputs = wrapper.querySelectorAll("input[type='checkbox']")
            
            if(active){
                el.classList.remove('-active')
                el.innerHTML = "<span>すべて選択</span>"
            }else{
                el.classList.add('-active')
                el.innerHTML = "<span>すべて解除</span>"
            }
            if(inputs.length > 0){
                inputs.forEach(i => {
                    i.checked = !active
                })
            }
        })
    }
    _attachToggle(el){
        el.addEventListener( 'click', (e) => {
            const active = el.classList.contains('-active')
            const id = el.getAttribute('data-filter-toggle')
            const toggleTarget = document.querySelector('#' + id )
            
            el.classList.toggle('-active')
            el.setAttribute("aria-expanded",!active)
            if(toggleTarget){
                toggleTarget.classList.toggle("-active")
            }
        })
    }
    _attachProjectToggle(el){
        el.addEventListener( 'click', (e) => {
            const active = el.classList.contains('-active')
            const id = el.getAttribute('data-project-toggle')
            const toggleTarget = document.querySelector('#' + id )
            const span = el.querySelector('span')
            el.setAttribute("aria-expanded",!active)
            if(active){
                el.classList.remove('-active')
                span.innerText = "詳しい情報を見る"
            }else{
                el.classList.add('-active')
                span.innerText = "閉じる"
            }
            if(toggleTarget){
                toggleTarget.classList.toggle("-active")
            }
        })
    }
}